<template>
    <div class="row">
        <div class="questionList col-3">
            <b-list-group >
                <b-list-group-item  v-for="(question,index) in questionLists" :key="question.question_type_cde" class="d-flex justify-content-between align-items-center" @click="getQuestionDetail(question['question_type_cde'])" >
                    {{question["question_type_desc"]}}
                    <!-- Used this for user attempts -->
                    <b-badge variant="primary" pill>{{question['quest'+index]}}</b-badge>
                </b-list-group-item>
            </b-list-group>
        </div>
        <div class="questiondesc col-9" v-if="selectedquestion">
             <app-readAloud v-if="selectedquestion=='1'"/>
             <app-repeateSentence v-if="selectedquestion=='2'"/>
             <app-describeImage v-if="selectedquestion=='3'" />
             <app-retellLecture v-if="selectedquestion=='4'"/>
             <app-answerShortQuestions v-if="selectedquestion=='5'" />
        </div>
    </div>
</template>
<script>
import { mapActions,mapGetters } from 'vuex'
import readAloud from './readaloud'
import repeateSentence from './repeatesentence'
import describeImage from './describeImage'
import retellLecture from './retellLecture'
import answerShortQuestions from './answerShortQuestions'

export default {
    components:{
        'app-readAloud':readAloud,
        'app-repeateSentence':repeateSentence,
        'app-describeImage':describeImage,
        'app-retellLecture':retellLecture,
        'app-answerShortQuestions':answerShortQuestions
    },
    data(){
        return{
            questionLists:{
                type: Object,
                required: true
            },
            selectedquestion: null
        }
    },
    methods:{
        ...mapActions({
            questionservice: 'createquestion/fetchQuestion'
        }),
        ...mapGetters({
            getQuestionList: 'createquestion/questions'
        }),
        getQuestionDetail(questionId){
            
            this.selectedquestion = questionId
            ////console.log(this.selectedquestion)
        },
        getQuestionTypes(){
            this.questionservice('getquestiontypes/getspeakingmodules').then(()=>{
            this.questionLists = this.getQuestionList().data
            ////console.log(this.questionLists)
        })
        }
    },
    beforeMount(){
        this.getQuestionTypes()
    }
}
</script>
<style scoped>

</style>
<style>
.btn-light, .btn-outline-danger
{

/* padding: 3px 7px!important; */
    border: 1px solid #ced4da!important;
    color: rgb(94, 114, 228);
    /* margin-left: 5px; */
    /* margin-top: 1px; */
    /* margin-bottom: 1px; */
    background: #fff!important;
}
/* .btn-outline-danger, .btn-outline-danger:hover, .btn-outline-danger:active, .btn-outline-danger:focus
{
    color:#dc3545!important;
    background: #fff!important;
} */
.btn-light:hover, .btn-light:active, .btn-light:focus
{
    color: rgb(94, 114, 228);
}
.btn-light:not(:disabled)
{
    border: 1px solid #5e72e4 !important;
}
.btn-outline-danger:not(:disabled)
{
    border: 1px solid #dc3545 !important;
}
.btn-light:not(:disabled)
{
    /* border-left: 0px!important; */
    border-top-left-radius: 0px!important;
    border-bottom-left-radius: 0px!important;
}
.extraNote
{
    color:#ccc;
}
button.btn-outline-warning, button.btn-outline-success
{
  font-size: .8rem;
  font-size: 1rem;
  padding: 0.375rem 0.5rem;
}
</style>